import { render, staticRenderFns } from "./EventScheduled.vue?vue&type=template&id=5bc68ce8&"
import script from "./EventScheduled.vue?vue&type=script&lang=js&"
export * from "./EventScheduled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports